import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable, OnDestroy, inject } from '@angular/core';
import device, { Device } from 'current-device';
import { BehaviorSubject, Subscription } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

const COMPACT_LAYOUT_QUERY = '(max-width: 1050px), (max-height: 700px)';

@Injectable({
  providedIn: 'root'
})

export class MobileResolutionService implements OnDestroy {
  private mobileResolution: boolean = false;
  private mobileVisiblePanel: string = "";
  private mobilevisibleRoutePanel: string = "";
  private readonly compactLayoutSubscription: Subscription;
  public ObservableMobileResolution: BehaviorSubject<boolean>;
  public ObservableMobileVisiblePanel: BehaviorSubject<string>;
  public ObservableMobileVisibleRoutePanel: BehaviorSubject<string>;

  private readonly breakpointObserver = inject(BreakpointObserver);

  constructor() {
    this.mobileResolution = this.breakpointObserver.isMatched(COMPACT_LAYOUT_QUERY);
    this.ObservableMobileResolution = new BehaviorSubject<boolean>(this.mobileResolution);
    this.ObservableMobileVisiblePanel = new BehaviorSubject<string>(this.mobileVisiblePanel);
    this.ObservableMobileVisibleRoutePanel = new BehaviorSubject<string>(this.mobilevisibleRoutePanel);

    this.compactLayoutSubscription = this.breakpointObserver.observe([COMPACT_LAYOUT_QUERY])
      .pipe(
        map((state) => state.matches),
        distinctUntilChanged()
      )
      .subscribe((isCompactLayout) => {
        this.setMobileResolution(isCompactLayout);
      });
  }

  public setMobileResolution(res: boolean): void {
    this.mobileResolution = res;
    this.ObservableMobileResolution.next(res);
  }

  public getMobileResolution(): boolean {
    return this.mobileResolution;
  }

  public setMobileVisiblePanel(name: string): void {
    this.mobileVisiblePanel = name;
    this.ObservableMobileVisiblePanel.next(name);
  }

  public getMobileVisiblePanel(): string {
    return this.mobileVisiblePanel;
  }

  public setMobileVisibleRoutePanel(name: string): void {
    this.mobilevisibleRoutePanel = name;
    this.ObservableMobileVisibleRoutePanel.next(name);
  }

  public getMobileVisibleRoutePanel(): string {
    return this.mobilevisibleRoutePanel;
  }

  public isPortrait(): boolean {
    if (window.innerHeight > window.innerWidth) {
      return true;
    }
    else {
      return false;
    }
  }

  public getDevice(): Device {
    return device;
  }

  ngOnDestroy(): void {
    if (this.compactLayoutSubscription) {
      this.compactLayoutSubscription.unsubscribe();
    }
  }
}
